import React from 'react';
import PropTypes from 'prop-types';

class DashboardOverview extends React.Component {

	render() {
		return (
			<div className='dashboard-overview-container'>
				<div className='row'>
					<div className={`${this.props.show_videos ? 'col-md-12' : 'col-md-4'} col-xs-12`}>
						<section className='panel panel-featured-left panel-featured-secondary'>
							<div className='panel-body widget-container animated fadeInDown' >
								<div className='widget-summary' >
									<div className='widget-summary-col widget-summary-col-icon'>
										<div className='summary-icon bg-secondary'>
											<i className='fa fa-usd'></i>
										</div>
									</div>
									<div className='widget-summary-col'>
										<div className='summary'>
											<h4 className='title  dashboard-overview-titles'>Completed Sales This Year</h4>
											<div className='info'>
												<strong className='amount'>{`$${Number(this.props.completed_sales).toLocaleString() || 0}`}</strong>
											</div>
										</div>
									</div>
								</div>
							</div>
						</section>
					</div>

					<div className={`${this.props.show_videos ? 'col-md-12' : 'col-md-4'} col-xs-12`}>
						<section className='panel panel-featured-left panel-featured-primary'>
							<div className='panel-body widget-container'>
								<div className='widget-summary'>
									<div className='widget-summary-col widget-summary-col-icon'>
										<div className='summary-icon bg-primary'>
											<i className='fa fa-life-ring'></i>
										</div>
									</div>
									<div className='widget-summary-col'>
										<div className='summary'>
											<h4 className='title dashboard-overview-titles'>Open Leads</h4>
											<div className='info'>
												<strong className='amount'>{this.props.open_leads || 0}</strong>
											</div>
										</div>
									</div>
								</div>
							</div>
						</section>
					</div>

					<div className={`${this.props.show_videos ? 'col-md-12' : 'col-md-4'} col-xs-12`}>
						<section className='panel panel-featured-left panel-featured-tertiary'>
							<div className='panel-body widget-container'>
								<div className='widget-summary'>
									<div className='widget-summary-col widget-summary-col-icon'>
										<div className='summary-icon bg-tertiary'>
											<i className='fa fa-shopping-cart'></i>
										</div>
									</div>
									<div className='widget-summary-col'>
										<div className='summary'>
											<h4 className='title dashboard-overview-titles'>Estimated Value From Leads</h4>
											<div className='info'>
												<strong className='amount'>{`$${Number(this.props.open_leads_value).toLocaleString() || 0}`}</strong>
											</div>
										</div>
									</div>
								</div>
							</div>
						</section>
					</div>
				</div>
			</div>
		)
	}
}

export default DashboardOverview;



// WEBPACK FOOTER //
// ./src/browser/components/dashboard/dashboardOverview.js